import { useEffect, useState } from "react";
import { Loader2, RefreshCw, Send } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, timeAgo } from "@/lib/api";
import { ConfirmAction } from "@/components/common";
import { Button } from "@/components/ui/button";

export const RefreshBar = ({ onDone }) => {
  const [d, setD] = useState(null);
  const load = () => api.get("/admin/facts/refresh").then((r) => setD(r.data));
  useEffect(() => { load(); }, []);
  useEffect(() => { if (!d?.running) return undefined; const t = setInterval(() => { load(); onDone(); }, 5000); return () => clearInterval(t); }, [d?.running]); // eslint-disable-line
  const refresh = async () => { try { await api.post("/admin/facts/refresh"); toast.success("Fetching and checking news in the background"); load(); } catch (e) { toast.error(errMsg(e)); } };
  const last = d?.runs?.[0];
  return (
    <section className="surface flex flex-wrap items-center gap-3 p-5" data-testid="refresh-bar">
      <div className="w-full min-w-0 sm:w-auto sm:flex-1">
        <p className="font-medium">Automatic news refresh: every few minutes</p>
        <p className="text-xs text-slate-500" data-testid="refresh-last-run">
          {d?.running ? <span className="inline-flex items-center gap-1"><Loader2 size={12} className="animate-spin" />Running now…</span>
            : last ? `Last run ${timeAgo(last.started_at)} (${last.trigger}): ${last.ingested} new articles, ${last.checked} checked, ${last.published} auto-published${last.failed_sources?.length ? ` · unreachable: ${last.failed_sources.join(", ")}` : ""}` : "No runs yet."}
          {" "}Fetches every approved source, checks the newest items and publishes Verified, Corroborated, One side only and Single approved source results automatically.</p>
      </div>
      <Button variant="outline" className="rounded-full" disabled={d?.running} onClick={refresh} data-testid="refresh-now-btn"><RefreshCw size={14} className="mr-1.5" />Fetch & check now</Button>
    </section>
  );
};

export const PublishAll = ({ pending, onDone }) => {
  const publishAll = async () => { try { const { data } = await api.post("/admin/facts/publish-checked"); toast.success(`${data.published} items published to Facts`); onDone(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <ConfirmAction testid="publish-all" title={`Publish all ${pending} items waiting for your decision?`} description="Each goes live on Facts with its verification label (for example Disputed). Matching Live records update automatically." confirmLabel="Publish all" onConfirm={publishAll}
      trigger={<Button size="sm" variant="outline" className="rounded-full" disabled={!pending} data-testid="publish-all-btn"><Send size={14} className="mr-1.5" />Publish all as labelled ({pending})</Button>} />
  );
};
